import React, { useState } from 'react';
import { Button } from '../../ui/button';
import { Input } from '../../ui/input';
import { Textarea } from '../../ui/textarea';
import { Card, CardContent, CardHeader, CardTitle } from '../../ui/card';
import useLocalization from '../../../hooks/useLocalization';

const initialSurveyData = {
  title: '',
  description: '',
  groups: [],
  footer: ''
};

export default function CustomerSurvey({ data = initialSurveyData, onSubmit, disabled = false }) {
  const { translate } = useLocalization();
  const [survey, setSurvey] = useState(() => {
    const initialAnswers = { ...data };
    initialAnswers.groups = data.groups?.map(group => ({
      ...group,
      questions: group.questions.map(question => ({
        ...question,
        answer: question.answer || ''
      }))
    }));
    return initialAnswers;
  });

  const updateAnswer = (groupIndex, questionIndex, answer) => {
    setSurvey(prev => ({
      ...prev,
      groups: prev.groups.map((group, gIndex) =>
        gIndex === groupIndex
          ? {
              ...group,
              questions: group.questions.map((question, qIndex) =>
                qIndex === questionIndex ? { ...question, answer } : question
              )
            }
          : group
      )
    }));
  };

  const handleSubmit = () => {
    onSubmit(survey);
  };

  return (
    <div className="p-4">
      <div className="flex flex-col gap-4">
        <div className="space-y-4">
          <h1 className="text-2xl font-bold text-gray-900">{survey.title}</h1>
          {survey.description && <p className="text-base text-gray-600 leading-relaxed">{survey.description}</p>}
        </div>

        {/* Question Groups */}
        {survey.groups.map((group, groupIndex) => (
          <Card key={groupIndex}>
            <CardHeader>
              <CardTitle className="text-lg font-semibold text-gray-800">{group.name}</CardTitle>
            </CardHeader>
            <CardContent className="space-y-4">
              {group.questions.map((question, questionIndex) => (
                <div key={`${groupIndex}-${questionIndex}`} className="space-y-2">
                  <label>
                    <span className="font-sm font-sm mr-2 text-gray-700">Q{questionIndex + 1}:</span>
                    <span className="text-black">{question.question}</span>
                  </label>

                  {question.type === 'short' ? (
                    <Input
                      placeholder="Enter your answer"
                      value={question.answer}
                      onChange={e => updateAnswer(groupIndex, questionIndex, e.target.value)}
                      className="border border-gray-500"
                      disabled={disabled}
                    />
                  ) : (
                    <Textarea
                      placeholder="Enter your answer"
                      value={question.answer}
                      onChange={e => updateAnswer(groupIndex, questionIndex, e.target.value)}
                      rows={3}
                      className="border border-gray-500"
                      disabled={disabled}
                    />
                  )}
                </div>
              ))}
            </CardContent>
          </Card>
        ))}

        {data.footer && (
          <div className="py-3 rounded-lg">
            <p className="text-sm text-gray-800 font-medium leading-relaxed text-left">{data.footer}</p>
          </div>
        )}

        {/* Submit Button */}
        <div className="flex gap-4 justify-end mt-4">
          <Button onClick={handleSubmit} disabled={disabled} className="px-6 py-2">
            {translate('submit')}
          </Button>
        </div>
      </div>
    </div>
  );
}
